/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export const TEST_TOOL_FORM_LABELS = {
  testToolAlert: 'test-tool-alert',
  testToolLoadingSpinner: 'test-tool-loading-spinner',
  testToolOutputField: 'test-tool-output-field',
};

export const TEST_TOOL_DATA_IDS = {
  testToolInputField: 'Test tool input field',
  testToolRunButton: 'test-tool-run-button',
  testToolValidationMessage: 'generative-content-tool-validation-message',
};

export const TEST_TOOL_INPUT_LIMITS = {
  maxMessageLength: 5000,
  showNumCharactersTypedLength: 2500,
};
